import { render, staticRenderFns } from "./tuitionOrderV2.vue?vue&type=template&id=d02e1f36"
import script from "./tuitionOrderV2.vue?vue&type=script&lang=js"
export * from "./tuitionOrderV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports